export type CAViewMode = 'accordion' | 'grid';

const STORAGE_KEY = 'seesor.correctiveActions.viewMode';

export const getStoredCAViewMode = (): CAViewMode => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'grid' ? 'grid' : 'accordion';
  } catch {
    return 'accordion';
  }
};

export const setStoredCAViewMode = (mode: CAViewMode): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // ignore storage errors (e.g. private browsing)
  }
};
